import React, { memo } from 'react';
import { useDispatch } from 'react-redux';
import documentEditMode from '../../constants/documentEditMode';
import EditableItem from '../../EditableItem/EditableItem';
import editDocumentActions from '../../store/actions/edit-document.actions';
import { ucFirst } from '../utils/ucFirst';
import useDocsAppealTopicsQuery from '../../queries/useDocsAppealTopicsQuery';
import useDocsTopicsQuery from '../../queries/useDocsTopicsQuery';
import { docTypes } from '../../constants/documents.constants';

const SubjectCell = memo(
  ({ record, getPopupContainer = () => document.body }) => {
    const dispatch = useDispatch();

    const type = record.type && record.type.id;

    const { data: topicsData = [] } = useDocsTopicsQuery({
      staleTime: Infinity,
    });

    const { data: appealTopicsData = [] } = useDocsAppealTopicsQuery({
      staleTime: Infinity,
    });

    const optionsTopic =
      type === docTypes.citizenAppeal ? appealTopicsData : topicsData;

    const textTopicId = optionsTopic?.find(
      (t) => t.id === record.topicId
    )?.name;

    const showTopicId = Boolean(textTopicId);

    return (
      <>
        {showTopicId ? (
          <EditableItem
            editText="Изменить тему документа"
            record={record}
            onClick={(e) => {
              e.stopPropagation();
              dispatch(
                editDocumentActions.openModal({
                  ...record,
                  editMode: documentEditMode.TOPIC_ID,
                })
              );
            }}
            itemText={textTopicId}
            style={{ lineHeight: '19px' }}
            getPopupContainer={getPopupContainer}
          />
        ) : (
          <EditableItem
            editText="Изменить произвольную тему документа"
            record={record}
            onClick={(e) => {
              e.stopPropagation();
              dispatch(
                editDocumentActions.openModal({
                  ...record,
                  editMode: documentEditMode.TOPIC,
                })
              );
            }}
            itemText={ucFirst(record.topic)}
            style={{ lineHeight: '19px' }}
            getPopupContainer={getPopupContainer}
          />
        )}
      </>
    );
  }
);

export default SubjectCell;
